import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { Compass } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="pt-16">
      <SEO title="Page not found · Istanbul Free Walking Tours" description="The page you're looking for doesn't exist." path="/404" />
      <section className="section text-center">
        <div className="container-x max-w-[520px] mx-auto">
          <div className="mx-auto w-16 h-16 rounded-full bg-[var(--ri-cream)] border border-[var(--ri-border)] flex items-center justify-center mb-6">
            <Compass className="text-[var(--ri-red)]" size={28} />
          </div>
          <p className="eyebrow mb-3">404</p>
          <h1 className="font-serif-display text-[32px] md:text-[40px] leading-[1.1]">
            This page wandered off somewhere in Istanbul.
          </h1>
          <p className="mt-4 text-[15.5px] leading-[1.75] text-[var(--ri-ink-soft)]">
            The page you're looking for doesn't exist or may have moved. Let's get you back on track.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="btn-primary">Back to home</Link>
            <Link to="/tours" className="btn-outline">Browse tours</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFoundPage;
